
<div mat-dialog-header class="title">
  Live Tag Settings
</div>
<div mat-dialog-content>
	  <div class="flex-column">
		<mat-form-field *ngIf="showTimes">
			<mat-label>Begin</mat-label>
			<date-time-picker [(value)]="begin"></date-time-picker>
		</mat-form-field>
		<mat-form-field *ngIf="showTimes">
			<mat-label>End</mat-label>
			<date-time-picker [(ngModel)]="end"></date-time-picker>
		</mat-form-field>
		<mat-form-field *ngIf="benchHeightOption?.length > 0; else manualBenchHeight">
			<mat-label>Bench Height</mat-label>
			<div class="input-wrapper">
				<mat-select [(ngModel)]="benchHeight">
					<mat-option *ngFor="let option of benchHeightOption" [value]="option.value">{{ option.label }}</mat-option>
				</mat-select>
				<div class="bench-unit">
					{{unitStr}}
				</div>
			</div>
		</mat-form-field>
		<ng-template #manualBenchHeight>
			<mat-form-field>
				<mat-label>Bench Height</mat-label>
				<measurement-input type="distance" [unitSystem]="(particleSizeUnitSystem$|async)"
					[(ngModel)]="benchHeight"></measurement-input>
			</mat-form-field>
		</ng-template>
		
		<mat-form-field *ngIf="benchSeamOption?.length > 0; else manualBenchSeam">
			<mat-label>Bench Seam</mat-label>
			<div class="input-wrapper">
				<mat-select [(ngModel)]="benchSeam">
					<mat-option *ngFor="let option of benchSeamOption" [value]="option">{{ option }}</mat-option>
				</mat-select>
			</div>
		</mat-form-field>
		<ng-template #manualBenchSeam>
			<mat-form-field>
				<mat-label>Bench Seam</mat-label>
				<input matInput type="text" [(ngModel)]="benchSeam"/>
			</mat-form-field>
		</ng-template>
		<mat-form-field *ngIf="materialTypes?.length > 0; else materialTypeTextField">
			<mat-label>Material Type</mat-label>
			<mat-select  [value]="typeMaterial$ | async" [disabled]="materialTypes?.length === 0"  (valueChange)="typeMaterial$.next($event)"> 
			  <mat-option *ngFor="let opt of materialTypes" [value]="opt">
				{{ opt }}
			  </mat-option>
			</mat-select>
		  </mat-form-field>
		  
		  <!-- Simple Text Input if materialTypes is empty or null -->
		  <ng-template #materialTypeTextField>
			<mat-form-field>
			  <mat-label>Material Type</mat-label>
			  <input matInput type="text" [(ngModel)]="materialType"/>
			</mat-form-field>
		  </ng-template>
		<mat-form-field>
			<mat-label>Truck Load Count</mat-label>
			<measurement-input type="count" [(ngModel)]="truckLoadCount"></measurement-input>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Truck Material Density</mat-label>
			<measurement-input type="largeDensity" [unitSystem]="(quantityUnitSystem$|async)" [(ngModel)]="truckMaterialDensity"></measurement-input>
		</mat-form-field>
		<mat-form-field>
			<mat-label>Comments</mat-label>
			<textarea matInput [(ngModel)]="comments"></textarea>
		</mat-form-field>
	  </div>
  </div>
  <div mat-dialog-actions>
	  <button mat-button (click)="cancel()">Cancel</button>
	  <button mat-flat-button color="primary" [disabled]="!valid()" (click)="save()">Save</button>
  </div>
